<div class="product-code-search-container" (keydown)="onKeyDown($event)">
	<input pInputText [(ngModel)]="productCode" class="product-code" (keyup)="onKeyUp($event)" [ngClass]="{'ng-touched': touched, 'ng-valid': valid, 'ng-invalid': !valid }">
	<div class="options" *ngIf="products.length > 0">
		<div [id]="'product_code_search_option_'+i" *ngFor="let product of products; let i = index" [ngClass]="{active: activeIndex == i}" (click)="selectProduct(product)">{{product.productCode}} - {{product.modelName}}</div>
	</div>
</div>
